import { render, staticRenderFns } from "./replacement.vue?vue&type=template&id=747d7393&scoped=true"
import script from "./replacement.vue?vue&type=script&lang=js"
export * from "./replacement.vue?vue&type=script&lang=js"
import style0 from "./replacement.vue?vue&type=style&index=0&id=747d7393&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747d7393",
  null
  
)

export default component.exports